
import axios from 'axios';


const server = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { 'Content-Type': 'application/json' }
})

export class UberEatsFetchAPI {

    //Function to update a store status on UberEats
    static async updateStoreStatus(branchoffice_id, status, token) {
        const res = await server(`/ubereats/store`, {
            method: "put",
            headers: { 'x-access-token': token },
            data: {
                branchoffice_id: branchoffice_id,
                status: status
            }
        });
        return res
    }

    //Function to get a store status on UberEats
    static async getStoreStatus(branchoffice_id, token) {
        const res = await server(`/ubereats/store?branchoffice_id=${branchoffice_id}`, {
            method: "get",
            headers: { 'x-access-token': token }
        });
        return res
    }

}

